/*
 * YAMIWARD — THE CODEX
 * Records Office files. One entry per design; product cards link into their dossier.
 * Static first-party data only — no user input is rendered here.
 */
(function () {
    'use strict';

    var CDN = 'https://cdn.shopify.com/s/files/1/0674/5273/1479/files/';

    // Faction accents (matches brand line colors)
    var FACTIONS = {
        ward: { label: 'YAMIWARD', color: '#C9CDD6' },
        kage:     { label: 'KAGE DIVISION', color: '#39FF6A' },
        oniworks: { label: 'ONIWORKS HEAVY INDUSTRIES', color: '#E51E25' },
        yurei:    { label: 'YUREI SUPPLY CO.', color: '#7FD9E8' },
        phantom:  { label: 'PHANTOM UNIT 07', color: '#FFB347' }
    };

    var THREAT_COLORS = { S: '#E51E25', A: '#FF7A1A', B: '#FFC93C', C: '#6FE38B', D: '#9AA0A6' };

    var ENTRIES = [
        {
            n: 1, match: 'Ward Insignia', faction: 'ward',
            name: 'KADOMORI', kanji: '門守', cls: 'Greater Oni', threat: 'S',
            status: 'SEALED — VOLUNTARY', haunt: 'The Torii Gate, Ward Zero', first: 'Before records',
            img: CDN + '7359575312077218209_2048.jpg?v=1785250435',
            fragment: 'The first oni. When the Ward settled between stops, Kadomori sealed itself into the gate rather than choose a side of it. Every resident passes under its gaze exactly twice: once arriving, once leaving — the count has never come out even. The insignia is its mark; wearing it means the gate has already let you through.',
            note: 'Do not thank the gate. It considers the debt open.'
        },
        {
            n: 2, match: 'Shadow Protocol', faction: 'kage', night: 'night',
            name: 'HANRENDER', kanji: '半影', cls: 'Kage — Signal-bound', threat: 'A',
            status: 'ACTIVE (render incomplete)', haunt: 'Kage Line, night service only', first: 'Drop 001',
            img: CDN + '951702738949070966_2048.jpg?v=1784427653',
            fragment: 'The 影 glyph rendered in wireframe because the entity itself never finished loading — half in this world, half out of it, and it has learned to use the missing half as a door. Kage Division adopted the glyph as its induction sigil. The neon signal-green fill means an asset is active. If you see the glyph fully rendered, solid black edge to edge, you are looking at Hanrender directly. Do not wait for it to finish.',
            note: 'Division policy: assets wearing the Protocol do not cast full shadows. This is considered a benefit.'
        },
        {
            n: 3, match: 'Live In The Shadows', faction: 'kage', night: 'night',
            name: 'THE OLD REGIMENT', kanji: '影に生きる', cls: 'Kage — Collective', threat: 'B',
            status: 'UNOBSERVED — NOT DECEASED', haunt: 'The margins. Alley between blocks 影-3 and 影-4', first: 'Drop 001',
            img: CDN + '8549846216774435134_2048.jpg?v=1784427634',
            fragment: 'The founding regiment of Kage Division took the motto literally. 影に生きる — live in the shadows — and one by one they stopped being observed, which is not the same as dying, whatever the paperwork says. The vertical typography on the mark is theirs; the small regiment stamps in the margin are roll call. Members still answer, on nights when the Kage line runs long.',
            note: 'The regiment is not lost. It is unaccounted for, which the regiment considers the entire point.'
        },
        {
            n: 4, match: 'Oni Mask', faction: 'oniworks',
            name: 'MITSUME', kanji: '三ツ目', cls: 'Tsukumogami (awakened foundry mask)', threat: 'A',
            status: 'ACTIVE — EMPLOYED', haunt: 'Oniworks Heavy Industries, foundry floor', first: 'Drop 001',
            img: CDN + '16966179593056860580_2048.jpg?v=1784427615',
            fragment: 'A foundry mask worn by three generations of Oniworks smiths until, in the way of hundred-year tools, it woke up. The third eye opens when the forge reaches temperature; the fangs came later and nobody at Oniworks will say from where. Mitsume does not haunt the foundry — it runs it. Union rules apply.',
            note: 'Forged loud is not a slogan. It is Mitsume’s hearing.'
        },
        {
            n: 5, match: 'Demon Forged', faction: 'oniworks',
            name: 'THE FIRST BILLET', kanji: '鬼', cls: 'Oni-steel — Relic', threat: 'B',
            status: 'DISTRIBUTED — BY DESIGN', haunt: 'Oniworks Bay 03, and everything struck from it', first: 'Drop 001',
            img: CDN + '18075580203447912259_2048.jpg?v=1784427597',
            fragment: 'The first billet of oni-steel, struck at Bay 03 at 1800 degrees with the 鬼 character stamped while the metal still remembered being something else. Everything Oniworks has forged since carries a fragment of the original billet, which is why the plate reads DEMON FORGED — as inventory disclosure, not marketing. The demon has not complained. The demon likes being everywhere.',
            note: 'Bay 03 runs 200 degrees hotter than its instruments report. The instruments are not wrong. The bay is lying.'
        },
        {
            n: 6, match: 'Not All Who Linger Are Lost', faction: 'yurei',
            name: 'THE PROPRIETOR', kanji: '店主', cls: 'Yūrei — Commercial', threat: 'C',
            status: 'EST. NOWHERE — DELIVERING EVERYWHERE', haunt: 'Yurei Supply Co. storefront (address changes nightly)', first: 'Drop 001',
            img: CDN + '16574213841149231398_2048.jpg?v=1784427579',
            fragment: 'Founder and sole permanent employee of Yurei Supply Co., depicted mid-dissolve and flanked by the two hitodama flames that handle stocking. The Proprietor lingers not because it is lost but because it is open — there is a difference, and the difference is posted by the register. Deliveries arrive on time from a company with no address, which the Transit Authority has agreed not to investigate.',
            note: 'All sales final. The Proprietor accepted its own terms long ago and finds them fair.'
        },
        {
            n: 7, match: 'Ghost Signal', faction: 'yurei', night: 'deep',
            name: 'THE GHOST LINE', kanji: '幽霊回線', cls: 'Denki spirit — Signal-class', threat: 'B',
            status: 'SIGNAL LOST / PRESENCE DETECTED', haunt: 'Last seen: everywhere', first: 'Drop 001',
            img: CDN + '18307686164687520713_2048.jpg?v=1784427560',
            fragment: '幽霊回線 — a transmission frequency that outlived its network. The RGB-split on the mark is not a style choice; it is what the signal looks like when it passes through you on the way to somewhere it remembers. Calls placed in the Ward after 2 a.m. occasionally connect to the Ghost Line. Records of what answers are kept by Yurei Supply Co., who insist the line is a valued customer.',
            note: 'If your device shows one bar in a dead zone, do not make the call. That bar is not for you.'
        },
        {
            n: 8, match: 'Squadron Roundel', faction: 'phantom', night: 'night',
            name: 'GHOST-7 · YK-07 KAGEROU', kanji: '陽炎', cls: 'Gen’ei — Phantom airframe', threat: 'S',
            status: 'MIA / ACTIVE — both are true', haunt: 'Ward airspace; contrails with no aircraft', first: 'Drop 001',
            img: CDN + '6524074441878606445_2048.jpg?v=1784427542',
            fragment: 'Airframe YK-07 KAGEROU, callsign GHOST-7, official roundel of Phantom Unit 07 — 幻影部隊. Declared missing in action on a date the squadron refuses to write down, and observed flying Ward airspace every night since. The contrail is real. The radar return is real. The aircraft has not been physically located, and Unit 07’s position is that this is a maintenance question, not an existential one.',
            note: 'KAGEROU — heat haze. Named for what it does to instruments. And to witnesses.'
        },
        {
            n: 9, match: 'Maintenance Bay 07', faction: 'phantom', night: 'night',
            name: 'BAY 07', kanji: '第七整備場', cls: 'Locus — Haunted infrastructure', threat: 'B',
            status: 'OPERATIONAL — CREWED', haunt: 'Airfield Sector 7 (it is the haunt)', first: 'Drop 001',
            img: CDN + '7574919733179842745_2048.jpg?v=1784427524',
            fragment: 'The maintenance bay assigned to an aircraft that cannot be physically located. The crew of Bay 07 services GHOST-7 nightly: parts are consumed, fluid levels drop, the logbook fills in a hand nobody claims. The service plates on the mark were pulled from the bay wall — damage report catastrophic, flying anyway. Someone stamped GROUNDED across the file. It was not grounded. The stamp has been reprimanded.',
            note: 'Bay 07’s tool inventory has been short one torque wrench since the disappearance. The crew leaves it off the order form. It is being used.'
        },
        {
            n: 10, match: 'Ward Gate', faction: 'ward',
            name: 'THE GATE', kanji: '闇区', cls: 'Threshold', threat: '—',
            status: 'OPEN. ALWAYS. THIS IS NOT REASSURING.', haunt: 'Terminus of all four lines. Location varies.', first: 'Before records',
            img: CDN + '5020772159789063254_2048.jpg?v=1784427505',
            fragment: 'The torii of 闇区, where all four lines meet and end. The Gate is the Ward’s only entrance and only exit, and it is not always in the same place, which residents describe as “considerate” — it comes to where it is needed. Kadomori (Entry 001) is sealed within it. The Records Office notes that the Gate has never been observed from behind.',
            note: 'The Gate does not decide who enters. It decides who was always going to.'
        },
        {
            n: 11, match: 'Transit Authority', faction: 'ward',
            name: 'THE TRANSIT AUTHORITY', kanji: '闇区交通局', cls: 'Institution', threat: 'N/A',
            status: 'IN SERVICE', haunt: 'The network itself', first: 'Founding charter (undated, notarized)',
            img: CDN + '8359004490486459856_2048.jpg?v=1784427484',
            fragment: 'The 闇区交通局 operates all four lines: Oni, Kage, Yūrei, Phantom. The Kage line runs only at night. The Yūrei line keeps no schedule and apologizes for none. The conductors are courteous, uniformed, and — per longstanding Ward custom — faceless, which regular riders stop noticing by the third trip. All lines terminate at the Gate. The Authority’s official map is accurate, which is different from being true.',
            note: 'Fare evasion is not enforced. The Authority prefers that you owe it.'
        }
    ];

    function pad(n) { return (n < 10 ? '00' : '0') + n; }

    // Night Parade tie-in: entities marked night are "sighted" 19:00–05:59;
    // the Ghost Line ('deep') only manifests 02:00–05:59. Flags set by night.js.
    function sightedNow(entry) {
        if (!entry.night) return false;
        if (entry.night === 'deep') return !!window.YW_DEEP_NIGHT;
        return !!window.YW_NIGHT;
    }

    function sightedBadge() {
        var b = document.createElement('span');
        b.className = 'codex-sighted';
        b.textContent = 'SIGHTED TONIGHT';
        return b;
    }

    function threatBadge(t) {
        var span = document.createElement('span');
        span.className = 'codex-threat';
        if (THREAT_COLORS[t]) {
            span.style.color = THREAT_COLORS[t];
            span.style.borderColor = THREAT_COLORS[t];
            span.textContent = 'CLASS ' + t;
            if (t === 'S') span.classList.add('codex-threat-s');
        } else {
            span.classList.add('codex-threat-null');
            span.textContent = t === 'N/A' ? 'N/A' : 'UNMEASURED';
        }
        return span;
    }

    function el(tag, cls, text) {
        var node = document.createElement(tag);
        if (cls) node.className = cls;
        if (text !== undefined) node.textContent = text;
        return node;
    }

    /* ---------- Dossier modal ---------- */

    var modal, dossier;

    function openDossier(entry) {
        if (!modal) return;
        var f = FACTIONS[entry.faction];
        dossier.innerHTML = '';
        dossier.style.setProperty('--dossier-accent', f.color);

        var head = el('div', 'dossier-head');
        head.appendChild(el('span', 'dossier-no', 'CODEX ENTRY ' + pad(entry.n)));
        head.appendChild(threatBadge(entry.threat));
        if (sightedNow(entry)) head.appendChild(sightedBadge());
        var close = el('button', 'dossier-close', '×');
        close.setAttribute('aria-label', 'Close dossier');
        close.addEventListener('click', closeDossier);
        head.appendChild(close);
        dossier.appendChild(head);

        var body = el('div', 'dossier-body');
        var imgWrap = el('div', 'dossier-img-wrap');
        var img = document.createElement('img');
        img.src = entry.img;
        img.alt = entry.name + ' — ' + f.label;
        img.loading = 'lazy';
        imgWrap.appendChild(img);
        body.appendChild(imgWrap);

        var info = el('div', 'dossier-info');
        info.appendChild(el('div', 'dossier-faction', f.label));
        var nameRow = el('h3', 'dossier-name', entry.name + ' ');
        nameRow.appendChild(el('span', 'dossier-kanji', entry.kanji));
        info.appendChild(nameRow);

        var rows = [
            ['CLASS', entry.cls],
            ['STATUS', entry.status],
            ['HAUNT', entry.haunt],
            ['FIRST RECORDED', entry.first]
        ];
        var table = el('div', 'dossier-rows');
        rows.forEach(function (r) {
            var row = el('div', 'dossier-row');
            row.appendChild(el('span', 'dossier-label', r[0]));
            row.appendChild(el('span', 'dossier-value', r[1]));
            table.appendChild(row);
        });
        info.appendChild(table);
        info.appendChild(el('p', 'dossier-fragment', entry.fragment));
        var noteP = el('p', 'dossier-note');
        noteP.appendChild(el('span', 'dossier-note-label', 'FIELD NOTE — '));
        noteP.appendChild(document.createTextNode(entry.note));
        info.appendChild(noteP);

        var btn = el('button', 'btn btn-primary dossier-shop-btn', 'VIEW THE MARK →');
        btn.addEventListener('click', function () {
            btn.blur(); // closing hides the dialog with aria-hidden: focus must not stay inside it
            closeDossier();
            scrollToProduct(entry.match);
        });
        info.appendChild(btn);

        body.appendChild(info);
        dossier.appendChild(body);

        modal.classList.add('open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('codex-modal-open');
    }

    function closeDossier() {
        if (!modal) return;
        modal.classList.remove('open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('codex-modal-open');
    }

    function scrollToProduct(match) {
        var cards = document.querySelectorAll('.product-card[data-product-title]');
        var target = null;
        for (var i = 0; i < cards.length; i++) {
            if (cards[i].getAttribute('data-product-title').indexOf(match) === 0) { target = cards[i]; break; }
        }
        // No matching card on this page (the Ward page has none since the shop moved to the homepage):
        // go to the store's grid. The layout prints the locale-aware root on <body> as data-root-url.
        if (!target) {
            var root = (document.body && document.body.getAttribute('data-root-url')) || '/';
            window.location.href = root.replace(/\/+$/, '') + '/collections/all';
            return;
        }
        var shop = document.getElementById('direct-shop');
        if (shop) shop.scrollIntoView({ behavior: 'smooth' });
        if (target) {
            setTimeout(function () {
                target.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
                target.classList.add('codex-flash');
                setTimeout(function () { target.classList.remove('codex-flash'); }, 2400);
            }, 450);
        }
    }

    /* ---------- Codex grid ---------- */

    function buildGrid() {
        var grid = document.getElementById('codex-grid');
        if (!grid) return;
        ENTRIES.forEach(function (entry) {
            var f = FACTIONS[entry.faction];
            var card = el('button', 'codex-card');
            card.type = 'button';
            card.style.setProperty('--codex-accent', f.color);
            card.setAttribute('aria-label', 'Open dossier: ' + entry.name);
            card.dataset.codexEntry = String(entry.n);

            var top = el('div', 'codex-card-top');
            top.appendChild(el('span', 'codex-card-no', 'ENTRY ' + pad(entry.n)));
            top.appendChild(threatBadge(entry.threat));
            card.appendChild(top);

            card.appendChild(el('div', 'codex-card-kanji', entry.kanji));
            card.appendChild(el('h3', 'codex-card-name', entry.name));
            card.appendChild(el('div', 'codex-card-cls', entry.cls));
            card.appendChild(el('div', 'codex-card-faction', f.label));
            card.appendChild(el('span', 'codex-card-open', 'OPEN FILE +'));

            card.addEventListener('click', function () { openDossier(entry); });
            grid.appendChild(card);
        });
        updateNightBadges();
    }

    function updateNightBadges() {
        ENTRIES.forEach(function (entry) {
            var card = document.querySelector('.codex-card[data-codex-entry="' + entry.n + '"]');
            if (!card) return;
            var existing = card.querySelector('.codex-sighted');
            if (sightedNow(entry)) {
                if (!existing) {
                    var top = card.querySelector('.codex-card-top');
                    if (top) top.insertAdjacentElement('afterend', sightedBadge());
                }
            } else if (existing) {
                existing.parentNode.removeChild(existing);
            }
        });
    }

    /* ---------- Product card chips ---------- */

    function attachChips() {
        var cards = document.querySelectorAll('.product-card[data-product-title]');
        cards.forEach(function (card) {
            var title = card.getAttribute('data-product-title') || '';
            var entry = null;
            for (var i = 0; i < ENTRIES.length; i++) {
                if (title.indexOf(ENTRIES[i].match) === 0) { entry = ENTRIES[i]; break; }
            }
            if (!entry) return;
            var info = card.querySelector('.product-info');
            var desc = card.querySelector('.product-desc-short');
            if (!info || !desc) return;
            var f = FACTIONS[entry.faction];
            var chip = el('button', 'codex-chip');
            chip.type = 'button';
            chip.style.setProperty('--codex-accent', f.color);
            chip.appendChild(el('span', 'codex-chip-diamond', '◈'));
            chip.appendChild(document.createTextNode(' CODEX ' + pad(entry.n) + ' — ' + entry.name));
            chip.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                openDossier(entry);
            });
            desc.insertAdjacentElement('afterend', chip);
        });
    }

    /* ---------- Init ---------- */

    function init() {
        modal = document.getElementById('codex-modal');
        dossier = document.getElementById('codex-dossier');
        if (modal) {
            var backdrop = document.getElementById('codex-modal-backdrop');
            if (backdrop) backdrop.addEventListener('click', closeDossier);
            document.addEventListener('keydown', function (e) {
                if (e.key === 'Escape' && modal.classList.contains('open')) closeDossier();
            });
        }
        buildGrid();
        attachChips();
        document.addEventListener('yw:nightchange', updateNightBadges);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    // Minimal public API for other Ward systems (quiz, future features).
    window.YW_CODEX = {
        entries: ENTRIES,
        factions: FACTIONS,
        sightedNow: sightedNow,
        open: function (n) {
            for (var i = 0; i < ENTRIES.length; i++) {
                if (ENTRIES[i].n === n) { openDossier(ENTRIES[i]); return true; }
            }
            return false;
        },
        scrollToProduct: scrollToProduct
    };
})();
